import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faEye, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './DayBasedOrderData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import moneda from '../../moneda';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


export default function DayBasedOrderData() {
    const [pedidos, setPedidos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [pedido, setPedido] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');
    const [productDeliveryDays, setProductDeliveryDays] = useState({});
    const [next7Days, setNext7Days] = useState([]);
    const [selectedDay, setSelectedDay] = useState(null);

    // removed old filter state: now filtering by selectedDay only
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    useEffect(() => {
        cargarPedidos();
    }, []);
    
    useEffect(() => {
        // fixed weekdays in order (Lunes -> Domingo)
        const names = ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'];
        const days = names.map(name => ({ name }));
        setNext7Days(days);
        if (days.length > 0) setSelectedDay(days[0]);
    }, []);


    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setPedidos(data.pedidos.reverse() || []);
            })
            .catch(error => console.error('Error al cargar pedidos:', error));
    };

    const implodeSelectedDays = (weeklyOrder) => {
        if (Array.isArray(weeklyOrder)) {
            return weeklyOrder.map(d => `${d.name} ${d.date}${d.deliver ? ' (Entregado)' : ''}`).join(', ');
        }
        return '';
    };

    const abrirModal = (item) => {
        setPedido(item);
        // Derive productDeliveryDays from the stored productos
        const productos = JSON.parse(item.productos || '[]');
        const derived = {};
        productos.forEach(p => {
            const id = p.idProducto;
            const daysMap = {};
            const wo = p.weeklyOrder;
            if (Array.isArray(wo)) {
                wo.forEach(d => {
                    daysMap[d.date] = !!d.deliver;
                });
            }
            if (id) derived[id] = daysMap;
        });
        // Initialize productDeliveryDays from stored weeklyOrder
        setProductDeliveryDays(derived);
        setNuevoEstado(item.estado)
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idPedido) => {
        // Build updated productos array where each product's weeklyOrder deliver flags are updated
        const productos = JSON.parse(pedido.productos || '[]');
        const updatedProductos = productos.map(p => {
            const id = p.idProducto;
            const daysState = productDeliveryDays[id] || {};
            const wo = p.weeklyOrder;
            if (Array.isArray(wo)) {
                // Update deliver flag on each day object (match by name/date)
                const newWo = wo.map(d => {
                    const key = d.date;
                    return {
                        ...d,
                        deliver: !!(key && daysState[key])
                    };
                });
                return { ...p, weeklyOrder: newWo };
            } else {
                return p;
            }
        });

        const payload = {
            estado: nuevoEstado !== '' ? nuevoEstado : pedido.estado,
            productos: JSON.stringify(updatedProductos),
            allDelivered: checkAllDelivered() === true ? 1 : 0
        };

        fetch(`${baseURL}/pedidoPut.php?idPedido=${idPedido}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarPedidos();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const filtrados = pedidos.filter(item => {
        if (!selectedDay) return true;
        try {
            const productos = JSON.parse(item.productos || '[]');
            return productos.some(prod => {
                const wo = prod.weeklyOrder || [];
                // assume weeklyOrder is an array of {name, date, deliver}
                return wo.some(d => d.name === selectedDay.name && d.deliver === false);
            });
        } catch (e) {
            return false;
        }
    });


    const recargarProductos = () => {
        cargarPedidos();
    };
    const invertirOrden = () => {
        setPedidos([...pedidos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };
    const descargarExcel = () => {
        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = JSON.parse(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad} - Dias: ${implodeSelectedDays(producto.weeklyOrder)}`);
            return {
                'ID Pedido': item.idPedido,
                'Estado': item.estado,
                'Nombre': item.nombre,
                'Email': item.email,
                'Telefono': item.telefono,
                'Pago': item.pago,
                'Entrega': item.entrega,
                'Nota': item.nota,
                'Productos': infoProductos.join('\n'),
                'Codigo': item.codigo,
                'Compania': item.companyName || item.userCompany,
                'Total': `${moneda} ${total.toFixed(2)}`,
                'Fecha': item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = `${moneda} ${totalGeneral.toFixed(2)}`;

        // Agregar fila con el total general
        const totalRow = {

            'ID Pedido': '',
            'Estado': '',
            'Nombre': '',
            'Email': '',
            'Telfono': '',
            'Pago': '',
            'Entrega': '',
            'Nota': '',
            'Productos': '',
            'Codigo': 'Total General:',
            'Compania': '',
            'Total': formattedTotal,
            'Fecha': '',
        };

        data.push(totalRow);

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'pedidos');
        XLSX.writeFile(wb, 'pedidos.xlsx');
    };


    const descargarPDF = () => {
        const pdf = new jsPDF('landscape'); // Orientación horizontal
        pdf.text('Lista de Pedidos', 10, 10);

        const columns = [
            { title: 'ID Pedido', dataKey: 'idPedido' },
            { title: 'Estado', dataKey: 'estado' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Email', dataKey: 'email' },
            { title: 'Telfono', dataKey: 'telefono' },
            { title: 'Pago', dataKey: 'pago' },
            { title: 'Entrega', dataKey: 'entrega' },
            { title: 'Nota', dataKey: 'nota' },
            { title: 'Productos', dataKey: 'productos' },
            { title: 'Codigo', dataKey: 'codigo' },
            { title: 'Compania', dataKey: 'compania' },
            { title: 'Total', dataKey: 'total' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = JSON.parse(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad}  - Dias: ${implodeSelectedDays(producto.weeklyOrder)}`);
            return {
                idPedido: item.idPedido,
                estado: item.estado,
                nombre: item.nombre,
                email: item.email,
                telefono: item.telefono,
                pago: item.pago,
                entrega: item.entrega,
                nota: item.nota,
                productos: infoProductos.join('\n'),
                codigo: item.codigo,
                compania: item.companyName || item.userCompany,
                total: `${moneda} ${total.toFixed(2)}`,
                createdAt: item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = `${moneda} ${totalGeneral.toFixed(2)}`;

        // Agregar fila con el total general
        const totalRow = {
            idPedido: '',
            estado: '',
            nombre: '',
            email: '',
            telefono: '',
            pago: '',
            entrega: '',
            nota: '',
            productos: '',
            codigo: 'Total General:',
            total: formattedTotal,
            createdAt: '',
        };

        data.push(totalRow);
        pdf.autoTable({
            columns,
            body: data,
            columnStyles: {
                productos: { cellWidth: 50, overflow: 'linebreak' },
                email: { cellWidth: 20, overflow: 'linebreak' },
                // nota: { cellWidth: 40, overflow: 'linebreak' },
            },
        });

        pdf.save('pedidos.pdf');
    };
    const handleDownloadPDF = () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
    // removed unused pageWidth
        let y = 10;

        // Agregar título
        pdf.setFontSize(10);


        // Obtener los detalles del pedido actualmente mostrado en el modal
        const pedidoActual = pedido;


        // Agregar detalles del pedido al PDF
        const pedidoData = [
            [`ID Pedido:`, `${pedidoActual.idPedido}`],
            [`Estado:`, `${pedidoActual.estado}`],
            [`Nombre:`, `${pedidoActual.nombre}`],
            [`Email:`, `${pedidoActual.email}`],
            [`Telefono:`, `${pedidoActual.telefono}`],
            [`Pago:`, `${pedidoActual.pago}`],
            [`Entrega:`, `${pedidoActual.entrega}`],
            [`Nota:`, `${pedidoActual.nota}`],
            [`Código:`, `${pedidoActual.codigo}`],
            [`Compania:`, `${pedidoActual.companyName || pedidoActual.userCompany}`],
            [`Total:`, `${moneda} ${pedidoActual.total}`],
            [`Fecha:`, `${pedidoActual.createdAt}`]
        ];
        pdf.autoTable({
            startY: y,
            head: [['Detalle del pedido', 'Valor']],
            body: pedidoData,
        });
        y = pdf.autoTableEndPosY() + 5;

        y += 5;

        // Obtener los productos del pedido actual
        const productosPedido = JSON.parse(pedidoActual.productos);

        // Generar sección de productos con imágenes y contenido
        for (let i = 0; i < productosPedido.length; i++) {
            if (y + 30 > pdf.internal.pageSize.getHeight()) {
                pdf.addPage();
                y = 10;
            }

            const producto = productosPedido[i];

            pdf.setFontSize(8);

            // Muestra la imagen a la izquierda de los datos del producto
            if (producto.imagen) {
                pdf.addImage(producto.imagen, 'JPEG', 15, y, 20, 20); // Ajusta el tamaño de la imagen aquí
            } else {
                // Si no hay URL de imagen, simplemente dejar un espacio en blanco
                pdf.text("Imagen no disponible", 5, y + 15);
            }

            if (producto) {
                pdf.text(`Producto: ${producto.titulo}`, 39, y + 3);
                pdf.text(`Precio: ${moneda} ${producto.precio}`, 39, y + 11);
                pdf.text(`Cantidad: ${producto.cantidad}`, 39, y + 15);
                pdf.text(`${producto.item}`, 39, y + 19);
                pdf.text(`${implodeSelectedDays(producto.weeklyOrder)}`, 39, y + 23);
            }

            y += 25; // Incrementar y para la siguiente posición
        }

        // Guardar el PDF
        pdf.save('pedido.pdf');
    };

    const handleDeliveryChange = (idProducto, day, isChecked) => {
        const existing = productDeliveryDays[idProducto] || {};

        const newProductDeliveryDays = {
            ...productDeliveryDays,
            [idProducto]: {
                ...existing,
                [day]: isChecked
            }
        };

        setProductDeliveryDays(newProductDeliveryDays);
    };
    const checkAllDelivered = () => {
        const productos = JSON.parse(pedido.productos);
        const allProductsDelivered = productos.every(producto => {
            const id = producto.idProducto;
            const wo = producto.weeklyOrder;
            const deliveredDays = productDeliveryDays[id] || {};
            return wo.every(dayObj => deliveredDays[dayObj.date] === true);
        });

        return !!allProductsDelivered;
    };


    return (
        <div>

            <ToastContainer />
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='dayButtonsRow'>
                        {next7Days.map(d => (
                            <button
                                key={d.name}
                                className={`dayBtn ${selectedDay && selectedDay.name === d.name ? 'active' : ''}`}
                                onClick={() => setSelectedDay(d)}
                            >{d.name}</button>
                        ))}
                    </div>
                    <button className='reload' onClick={recargarProductos}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>
                </div>
            </div>

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Pedido</th>
                            <th>Estado</th>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Telefono</th>
                            <th>Entrega</th>
                            <th>Pago</th>
                            <th>Total</th>
                            <th>Ganancias</th>
                            <th>Fecha</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtrados.map(item => (
                            <tr key={item.idPedido} className={item.allDelivered === 1 ? 'allDelivered' : 'deliveryPending'}>
                                <td>{item.idPedido}</td>

                                <td style={{
                                    color: item?.estado === 'Pendiente' ? '#DAA520' :
                                        item?.estado === 'Entregado' ? '#0000FF' :
                                            item?.estado === 'Rechazado' ? '#FF0000' :
                                                item?.estado === 'Pagado' ? '#008000' :
                                                    item?.estado === 'Recibido' ? '#008000' :
                                                    '#000000'
                                }}>
                                    {item?.estado}
                                </td>
                                <td>{item.nombre}</td>
                                <td>{item.email}</td>
                                <td>{item.telefono}</td>
                                <td>{item.entrega}</td>
                                <td>{item.pago}</td>
                                <td style={{ color: '#008000', }}>{moneda} {item.total}</td>
                                <td>{`${moneda} ${item.earning}`}</td>
                                <td>{item.createdAt}</td>
                                <td>
                                    <button className='editar' onClick={() => abrirModal(item)}>

                                        <FontAwesomeIcon icon={faEye} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Pedido
                                </button>
                                <button onClick={handleDownloadPDF} className='texto'>Descargar PDF</button>
                            </div>

                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>ID Pedido</legend>
                                    <input
                                        value={pedido.idPedido}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        value={pedido.nombre}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Email</legend>
                                    <input
                                        value={pedido.email}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input
                                        value={pedido.telefono}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Pago</legend>
                                    <input
                                        value={pedido.pago}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Entrega</legend>
                                    <input
                                        value={pedido.entrega}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Codigo</legend>
                                    <input
                                        value={pedido.codigo}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nota</legend>
                                    <input
                                        value={pedido.nota}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Fecha </legend>
                                    <input
                                        value={pedido.createdAt}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Compania </legend>
                                    <input
                                        value={pedido.companyName || pedido.userCompany}
                                        disabled
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select
                                        value={nuevoEstado !== '' ? nuevoEstado : pedido.estado}
                                        onChange={(e) => setNuevoEstado(e.target.value)}
                                    >
                                        <option value={pedido.estado}>{pedido.estado}</option>
                                        <option value="Entregado">Entregado</option>
                                        <option value="Rechazado">Rechazado</option>
                                        <option value="Pagado">Pagado</option>
                                        <option value="Pendiente">Pendiente</option>
                                        <option value="Recibido">Recibido</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Total </legend>
                                    <input
                                        value={pedido.total}
                                        disabled

                                    />
                                </fieldset>
                            </div>
                            <div className='cardsProductData editOrder'>
                                {JSON.parse(pedido.productos).map(producto => {
                                    return (
                                        <div key={producto.titulo} className='cardProductData'>
                                            <img className='productImage' src={producto.imagen} alt="imagen" />
                                            <div className='cardProductDataText'>
                                                <h3>{producto.titulo}</h3>
                                                <strong>{moneda} {producto.precio} <span>x{producto.cantidad}</span></strong>
                                                <span>{producto.item}</span>
                                                <div className='editDeliveryDaysWrapper'>
                                                    {producto.weeklyOrder && producto.idProducto && (() => {
                                                        const id = producto.idProducto;
                                                        const wo = producto.weeklyOrder;
                                                        // If weeklyOrder is an array of day objects
                                                        if (Array.isArray(wo)) {
                                                            return wo.map((d) => {
                                                                const dateKey =  d.date;
                                                                const stateVal = productDeliveryDays[id]?.[dateKey];
                                                                const checked = typeof stateVal === 'boolean' ? stateVal : !!d.deliver;
                                                                return (
                                                                    <div key={`${id}-${dateKey}`} className='editDeliveryDay'>
                                                                        <input type="checkbox" id={`${id}-${dateKey}`} value={dateKey} checked={checked} onChange={(e) => handleDeliveryChange(id, dateKey, e.target.checked)} />
                                                                        <label htmlFor={`${id}-${dateKey}`} className={checked ? 'strikethrough' : ''}>{`${d.name} ${dateKey}`}</label>
                                                                    </div>
                                                                );
                                                            });
                                                        }
                                                        return null;
                                                    })()}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            <button className='btnPost' onClick={() => handleUpdateText(pedido.idPedido)} >Guardar </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
